import React, {Fragment, useEffect, useState} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import FormService from "../../../../services/FormsService";

import Color from "color";


const TemplateCUAUrba2Demo = (props) => {
    const rnuFormService = new RNUFormService()
    const formService = new FormService();
    const [items, setItems]= useState([])
    const [items1, setItems1]= useState()
    const [annexes, setAnnexes] = useState();

    const fetchData = rnuFormService.getData('urba')
    const fetchData1 = rnuFormService.getData('urba1')

    useEffect(()=>{
        setAnnexes(formService.getEntityAnnexes())
    }, [])

    useEffect(()=>{


    }, [items1])


    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;
        setAnnexes(formService.getEntityAnnexes())
    },[fetchData])

    useEffect(()=>{
        (fetchData1)?setItems1(fetchData1):null;
    },[fetchData1])


    const renderRow=(item,index)=>{
        return(
            <Fragment key={index}>
                 <strong>Zone *********** : </strong><span >Lorem ipsum dolor sit amet.</span><br/>
            </Fragment>
        )
    }

    return (
        <div className="ue-section">
            <div>
                <div className="text-left text-underline">
                    <h3>{(props.formtype !== 'ru') ?'ARTICLE 2 - ':null}Disposition applicable</h3>
                </div>

                {(annexes?.a2_txt && annexes?.a2_txt !== '') ?
                    <p style={{'whiteSpace':'pre-line'}}  dangerouslySetInnerHTML={{__html:annexes.a2_txt.replace(/(?:\r\n|\r|\n)/g, '<br />')}}/>
                    : <>
                        <p>
                            Les articles suivants du code de l'urbanisme sont notamment applicables :
                            <br/>- art. L 111-1-4, art. R 111-2, R 111-4, R 111-15 et R 111-21.
                        </p>
                    </>
                }
                <div>
                    {(items1 && items1?.length>0)?
                        <p  style={{"paddingLeft": "20px"}}>
                            {
                                items1.map((item, index) => {
                                    return (renderRow(item, index))
                                })
                            }
                        </p>
                        :null
                    }
                </div>
            </div>
        </div>
    );
};

export default TemplateCUAUrba2Demo

